import { QueryOptions, queryOptions } from '@tanstack/react-query';
import { service } from '@maia/quotation';

export type Document = Awaited<ReturnType<(typeof service)['getDocuments']>>;

export function getDocumentsOptions(
  guid: string,
  search: Record<string, unknown> = {},
  initialData: QueryOptions<Document>['initialData'] = undefined,
) {
  return queryOptions({
    queryKey: ['documents', [guid], [search]],
    queryFn: async () => await service.getDocuments(guid),
    initialData,
  });
}
